import React, { createContext, useState, useMemo } from 'react';
import PropTypes from 'prop-types';

const EmployeeListContext = createContext();

const EmployeeListProvider = ({ children }) => {
  const [elQuery, setElQuery] = useState('');
  const [elPageValue, setElPageValue] = useState(1);
  const [elPageSizeValue, setElPageSizeValue] = useState(10);
  const [elValuesPresent, setElValuesPresent] = useState(false);
  const [elSortField, setElSortField] = useState('');
  const [elSortOrder, setElSortOrder] = useState('');

  const contextValue = useMemo(
    () => ({
      elQuery,
      setElQuery,
      elPageValue,
      setElPageValue,
      elPageSizeValue,
      setElPageSizeValue,
      elValuesPresent,
      setElValuesPresent,
      elSortField,
      setElSortField,
      elSortOrder,
      setElSortOrder,
    }),
    [elQuery, elPageValue, elPageSizeValue, elValuesPresent, elSortOrder, elSortField],
  );

  return (
    <EmployeeListContext.Provider value={contextValue}>{children}</EmployeeListContext.Provider>
  );
};

EmployeeListProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export { EmployeeListContext, EmployeeListProvider };
